export const alertConstants = {
  SHOW: "ALERT_SHOW",
  HIDE: "ALERT_HIDE"
};
